import { isAndroid, isIOS, isMobile, isTablet } from "react-device-detect";

/** iPadOS 13+ Safari reports a desktop Mac user agent. */
const isIPadOS = () =>
  typeof navigator !== "undefined" &&
  navigator.platform === "MacIntel" &&
  navigator.maxTouchPoints > 1;

/** Phones and tablets, detected by device rather than viewport width. */
export const isHandheldDevice = () => isMobile || isTablet || isIPadOS();

/** @returns {"ios" | "android" | "unknown"} */
export const getMobilePlatform = () => {
  if (isIOS || isIPadOS()) return "ios";
  if (isAndroid) return "android";
  return "unknown";
};
